module.exports = ".snackBar {\n  border-radius: 2px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-size: 14px;\n  left: calc(50vw - 150px);\n  min-height: 30px;\n  padding: 6px;\n  position: fixed;\n  text-align: center;\n  top: 70px;\n  width: 300px;\n  z-index: 9000; }\n\n.success {\n  background-color: #6cb91d;\n  color: #000000; }\n\n.error {\n  background-color: #eb415d;\n  color: #ffffff; }\n\n.warning {\n  background-color: #f4da64;\n  color: #000000; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/snackbar/snackbar.scss
// module id = ./src/app/components/snackbar/snackbar.scss
// module chunks = main